module.exports = {
  "language": "1",
  "success": true,
  "data": {
    "headText": {
      "pageOne": {
        "name" : "홈",
        "pageText" : {
          "Product" : "제품 디스플레이",
          "series" : {
            "one" : "태양 보호 시리즈",
            "two" : "수영복 시리즈",
            "three":"생활 시리즈"
          },
          "introduce" : {
            "patent" : "VVC 국가 특허 상표. 이 브랜드의 첫 번째 섬유 전환 광원은 자연광 (햇빛)을 피부에 필요한 스펙트럼으로 효과적으로 변환하여 사람들이 해당 제품을 착용 한 후 가장 편안하고 시원한 상태에서 세포 활성화를 경험할 수 있도록합니다. 실외 활동과 선 스크린 스킨 케어, 국제적인 디자인 컨셉 및 의료 전문 태도로 현대인의 요구를 결합하여 우리는 수퍼 선 스크린, 스킨 케어 및 건강 관리가 적용된 세련된 아웃 도어 제품을 만듭니다.",
            "brief" : "VVC 프로필"
          },
          "story" : {
            "storyText" : "브랜드 이야기",
            "brand" : {
              "idea" : "브랜드 컨셉",
              "style" : "제품 스타일",
              "origin" : "브랜드 원산지"
            }
          }
        }
      } ,
      "pageTwo": {
        "name" :"태양 보호"
      },
      "pageThree": {
        "name" :"수영복"
      } ,
      "pageFour": {
        "name" :"생활"
      },
      "pageFive":{
        "name" :"비전",
        "pageText" : {
          "visionText":"VVC 비전 시스템",
          "column" : "양동이에서 본 다양한 비디오 및 스타일링뿐 아니라 자연스러운 조합 선수의 화려한 공연 비디오 및 의상. 또한 데스크탑에서도 호스팅되는 이벤트 및 이벤트를 즐기기를 원합니다.。"
        }
      } ,
      "pageSix":{
        "name" : "공동 협력",
        "pageText" : {
          "storeText" : "VVC 아울렛",
          "address" : "주소",
          "addressText" : "1 층, 빌딩 127, 블록 B, Hangzhou Tower, No.1 Wulin Square, Hangzhou 310000, Hangzhou 이메일 : store_hangzhou_tower@givenchy.com 전화 번호 : +86 571 86 72 27 70"
        }
      } ,
      "pageSeven": {
        "name" :"보안 검사",
        "pageText" : {
          "query" : "인증 된 문의",
          "inputQuery" : "Taobao / Tmall ID를 입력하십시오.",
          "buttonQuery" : "클릭하여 질의"
        }
      },
      "pagenine":{
        "name":'Womens Strap Onepiece Swimsuit Black Flower',
        "span":" Size Small,Medium,Large Material",
        "shop":'필수 상품',
        "shops":'상품 합계',
        "chima":'사이즈 선택',
      "yasn":"색상 선택",
      "shuli":'수량',
      "hongs":' 적색',
      "bais":'흰색',
        "houmai":'쇼핑',
        'shoupcar':'장바구니에 가입하다',  
      },
      "foot":{
        "vvname":'vvc에 대하여',
        'ygkp':'양광커푸',
        'vvcfz':'유니크한 방직기술',
        'zlbl':'특허 원단',
        'ppsm':'브랜드 사명',
        "crfs":'성인 자외선 차단',
        'nxfs':'남성 자외선 차단',
        'nvfs':'여성 자외선 차단',
        "etfs":"어린이 자외선 차단",
        "lmhz":'연명으로 협력하다.',
        'mxlik':'여성 자외선 차단',
        'atls':'아오더레스',
        'msd':'면세점',

        "fwcx":'위조 방지 조회',
        'dlcx':'프록시 조회',
        'fcx':'위조 방지 조회',
        'tbtmcx':'타오바오톈마오 인증 조회',
        "zxrx":'자문 핫라인 400-1818-766',
      },
      "classlist":{
        "title":"인기 상품"
    },
      "entity":{
        "title":"VVC 오프라인 숍"
    },
    "viewmore":{
        "title":"더 보기"
    },
    "jojnt":{
      "pingpai":'브랜드 문의',
      "daili":'프록시 쿼리',
      "dangwei":'보안 검사',
      'tianmao':'Tmall 공인 조회',
      "qindail":'프록시 쿼리를 입력하십시오.',
      "qindanw":'보안 확인을 입력하십시오.',
      "qintian":'Tmall 쿼리를 입력하십시오.',
      "chaxun":'쿼리',
      "fangwibianm":'제품 포장에 12 자리 보안 코드를 입력하십시오.',
      "shouci":'첫 번째 조회는 제품의 신뢰성을 표시합니다. 사용자가 여러 번 제품 조회를 수행하지 않으면 공식 웹 사이트의 공식 웹 사이트에 문의하십시오.',
      "gongz":" 공개 번호 문의 VVC",
      'shouh':'애프터 서비스 400-1818-766',
      "searchResult":'조회 결과',
      'gengdyi':'공중번호로 더 알아보기',
      "chauxun":'조회 번호',
      "chuanxhsi":'조회 시간',
  }
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/data/ko.js